import React from 'react'
import {
  ListItem,
  withStyles,
  Grid
} from '@material-ui/core'
import shortener_urls from 'utils/ShortenerUrl'
import { Person } from '@material-ui/icons'
import { AccountOff } from 'mdi-material-ui'
import { FileCopy } from '@material-ui/icons'
import { CopyToClipboard } from 'react-copy-to-clipboard'
import { openSnackbar } from 'actions/view'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { Button } from '@material-ui/core'

const UrlItem = withStyles((theme) => ({
  heading: {
    fontSize: theme.typography.pxToRem(16),
    // fontWeight: 'bold',
    display: 'table',
    tableLayout: 'fixed',
    width: '100%',
    whiteSpace: 'nowrap',
    marginTop: 11,
  },
  text: {
    display: 'table-cell',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  secondaryAction: {
    [theme.breakpoints.up('xs')]: {
      paddingRight: 39,
    },
    [theme.breakpoints.up('md')]: {
      paddingRight: 60,
    },
  },
  container: {
    listStyle: 'none',
    borderBottom: '1px solid #adadad',
    borderRight: '1px solid #adadad',
  },
  secondaryActionRoot: {
    [theme.breakpoints.up('xs')]: {
      top: 'calc(50% - 16px)',
    },
    [theme.breakpoints.up('md')]: {
      top: 'calc(50% - 24px)',
    },
  },
  info: {
    display: 'inline-block',
    minHeight: 40,
    marginLeft: /* 75 */ 0,
    // [theme.breakpoints.down('sm')]: {
    //   marginLeft: 68,
    // },
  },
}))(({ classes, addOrEditPush, url, entityType, openSnackbar, isPinned }) => {
  const count = url.visits || 0
  const Icon = count ? Person : AccountOff

  const onCopy = () => {
    openSnackbar({
      type: "success",
      message: "Your file url was successfully copied to clipboard"
    })
  }
  return (
    <ListItem
      key={`${url.url_code}`}
      button
      style={{ borderBottom: '1px solid #adadad'}}
      classes={{
        container: classes.container,
        secondaryAction: classes.secondaryAction,
      }}
    >
      <Grid container>
        <Grid item sm={12} md={1} lg={1}>
          <div style={{fontSize: 12}}>
            <CopyToClipboard
              onCopy={() => {
                onCopy();
              }}
              text={
                shortener_urls.public_url + '/' + encodeURIComponent(url.url_code)
              }
            >
              <Button
                size={'small'}
                color="secondary"
                style={{ margin: 0 }}
              >
                <FileCopy style={{ marginRight: 5 }} />
                Copy
              </Button>
            </CopyToClipboard><br/>
         
            <Icon
              style={{ verticalAlign: 'middle', marginRight: 5, marginBottom: 2 }}
            />
            {`${count} Visit${count === 1 ? '' : 's'}`}
          </div>
        </Grid>
        
        <Grid item sm={12} md={5} lg={4}>
          <div style={{ margin: '16px 16px 0px 8px', fontSize: 12  }}><strong>{isPinned ? '📌 ' : ''}Short URL</strong> {shortener_urls.public_url}/{url.url_code}</div>
        </Grid>
        <Grid item sm={12} md={6} lg={7}>
          <div style={{ margin: '16px 16px 0px 8px', fontSize: 12 }}> <strong>Full URL</strong> {url.long_url}<br />
            <em style={{ color: 'grey', fontSize: 10 }}>Created: {new Date(url.date_created).toLocaleString()}</em>
          </div>
        
        </Grid>
      </Grid>
    

    </ListItem>
  )
})
export default connect(null, dispatch => bindActionCreators({ openSnackbar }, dispatch))(UrlItem)
